var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVanIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "color",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23 47",
    style: {
      enableBackground: "new 0 0 23 47"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,47.1h17c1.7,0,3-1.3,3-3v-25h-0.8V5.7c0-3.1-2.5-5.7-5.7-5.7H6.4C3.3,0,0.7,2.5,0.7,5.7v13.4H0v25 C0,45.8,1.4,47.1,3,47.1z M21.2,6l-4.8-4.8C19,1.2,21.2,3.3,21.2,6z M16,10.7c2.6,0,4.7,2.1,4.7,4.7v2.2c0,0-4.1-1.4-9.2-1.4 c-5.6,0-9.3,1.4-9.3,1.4v-2.2c0-2.6,2.1-4.7,4.7-4.7H16z M6.7,1.2L1.9,6C1.8,3.3,4,1.2,6.7,1.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVanIcon);
export default __webpack_public_path__ + "static/media/van_icon.02a97b4cd16354fd0b07fce60df8d9fb.svg";
export { ForwardRef as ReactComponent };